import React, { useEffect, useState } from 'react';
import { api } from '../utils/api';

// W7 — my AI spend against my limit and my partner's: a quiet line at 75 %, red at 90 % and over.
export default function UsageAlert({ style }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.usage.me().then(setS).catch(() => setS(null)); }, []);
  if (!s) return null;
  const lines = [];
  const say = (who, x) => {
    if (!x || !x.alert) return;
    lines.push({ red: x.alert === 'over' || x.alert >= 90,
      text: x.alert === 'over' ? `${who} AI limit for this month is used up (€${x.spent.toFixed(2)} of €${x.limit.toFixed(2)}).`
        : `${who} AI use this month is at ${x.pct} % of the limit (€${x.spent.toFixed(2)} of €${x.limit.toFixed(2)}).` });
  };
  say('Your', s.person);
  say(s.partner?.territory ? `${s.partner.territory}'s` : "The partner's", s.partner);
  if (!lines.length) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 12, ...style }}>
      {lines.map((l, i) => (
        <div key={i} style={{ fontSize: '0.82rem', padding: '7px 12px', borderRadius: 8, border: `1px solid ${l.red ? 'var(--gate)' : 'var(--line)'}`, color: l.red ? 'var(--gate)' : 'var(--body-ink)' }}>{l.text}</div>
      ))}
    </div>
  );
}
